import Vue from 'vue'
import auth from '@websanova/vue-auth'
import authBasic from '@websanova/vue-auth/drivers/auth/basic.js'
import httpAxios from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import routerVueRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js'
import oauth2Google from '@websanova/vue-auth/drivers/oauth2/google.js'
import oauth2Facebook from '@websanova/vue-auth/drivers/oauth2/facebook.js'

// oauth2Google.params.client_id = 'GOOGLE-OAUTH2-CLIENT-ID'
oauth2Facebook.params.client_id = process.env.VUE_APP_FB_APP_SECRET

Vue.use(auth, {
  auth: {
    request: function (req, token) {
      this.options.http.setHeaders.call(this, req, { Authorization: 'Token token=' + token })
    },
    response: function (res) {
      let headers = this.options.http.getHeaders.call(this, res),
        token = headers.Authorization || headers.authorization

      if (token) {
        token = token.split(/Token token=:?\s?/i)

        return token[token.length > 1 ? 1 : 0].trim()
      }
    },
  },
  http: httpAxios,
  router: routerVueRouter,
  oauth2: {
    google: oauth2Google,
    facebook: oauth2Facebook,
  },
})
